import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {Modulos} from "src/app/core/modulos";
import {AcessoModuloResolver} from "src/app/guards/acesso-modulo.resolve";
import {AuthGuard} from "src/app/guards/auth.guard";
import {CadastrarEixoComponent} from "./cadastrar-eixo/cadastrar-eixo.component";
import {EixoComponent} from "./eixo.component";

const routes: Routes = [
    {
        path: "eixo/cadastrar",
        component: CadastrarEixoComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.EIXO},
    },
    {
        path: "eixo",
        component: EixoComponent,
        canActivate: [AuthGuard],
        resolve: {perfilAcesso: AcessoModuloResolver},
        data: {modulo: Modulos.EIXO},
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class EixoRoutingModule {
}
